import { AlignmentMode } from '@/domain/anatomy/pelvis/alignment';

/**
 * Alignment mode (coordinate systems) for measurements related to the pelvis as represented on the API.
 *
 * - 'none' is the CT coordinate system
 * - 'APP' is the APP coordinate system, which is defined relative to the anterior-pelvic-plane
 * - 'FPP' is the FPP coordinate system, which is defined relative to the functional-pelvic-plane
 */
export type ApiAlignmentMode = 'none' | 'APP' | 'FPP';

/** Create a domain alignment-mode from its api-specific equivalent */
export function alignmentMode(apiMode: ApiAlignmentMode): AlignmentMode {
    switch (apiMode) {
        case 'none':
            return AlignmentMode.CT;
        case 'APP':
            return AlignmentMode.APP;
        case 'FPP':
            return AlignmentMode.FPP;
        default:
            throw new Error(`Invalid api-alignment-mode: ${apiMode}`);
    }
}
